export default {
  //api: "http://tadportal.com"
  //api: "http://localhost:3000"
  //api: "https://tad-web-api.azurewebsites.net"
  //api: "https://tad-web-api-prod.azurewebsites.net"
  api: process.env.REACT_APP_API_URL
};

